import { axiosBase, errorHandler } from "./axios";

const getBatch = (data: any) => {
  return axiosBase.get("batch/list", { params: data }).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const getBatchParams = (data: any) => {
  return axiosBase.get("batch/list", { params: data }).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const createBatch = (data: any) => {
  return axiosBase.post("batch/save", data).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const deleteBatch = (data: any) => {
  return axiosBase.delete(`batch/delete/${data}`).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const toggleBatch = (data: any) => {
  return axiosBase.post(`batch/save`, data).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const getAvailableUsers = (data: any) => {
  return axiosBase.get("batch/available-users", { params: data }).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const getAvailableStudents = (data: any) => {
  return axiosBase.get("batch/available-users", { params: data }).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const viewBatch = (data: any) => {
  return axiosBase.get(`batch/view/${data.id}?date=${data.date}`).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const getMarkedOffInstructors = (data: any) => {
  return axiosBase.get("batch/marked-off-instructors", { params: data }).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const getMarkedOffSessions = (data: any) => {
  return axiosBase.get("batch/marked-off-sessions", { params: data }).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const markBatchSession = (data: any) => {
  return axiosBase.post("batch/markBatchSession", data).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const markAttendance = (data: any) => {
  return axiosBase.post(`batch/markStudentAttendance`, data).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const getBatchHistory = (data: any) => {
  const { batchId, ...rest } = data;
  return axiosBase.get(`instructor-history/batch/${batchId}`, { params: rest }).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const getOverallStudentAnalytics = (data: any) => {
  console.log("data", data);
  const { id, studentId, ...rest } = data;
  return axiosBase.get(`batch/getOverallStudentAnalytics/${id}/${studentId}`, { params: rest }).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const getSessionAnalytics = (data: any) => {
  const { id, studentId, sessionId, ...rest } = data;
  return axiosBase.get(`batch/getSessionAnalytics/${id}/${studentId}/${sessionId}`, { params: rest }).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const getAvailableStudentsForBatch = (data: any) => {
  return axiosBase.get("batch/availableStudentsForBatch", { params: data }).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const getCalendarDetails = (data: any) => {
  return axiosBase.get("batch/getCalendarDetails", { params: data }).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

export const batchService = {
  createBatch,
  getBatch,
  getBatchParams,
  deleteBatch,
  getAvailableStudents,
  toggleBatch,
  markAttendance,
  getAvailableUsers,
  viewBatch,
  getBatchHistory,
  getMarkedOffInstructors,
  getMarkedOffSessions,
  markBatchSession,
  getOverallStudentAnalytics,
  getSessionAnalytics,
  getAvailableStudentsForBatch,
  getCalendarDetails
};
